/**
 * src/productPages/index.js
 *
 * Registry of bespoke product marketing pages.
 *
 * Each entry is a hand-composed page built from the shared VISINVOKE marketing
 * primitives (components/marketing/ViMarketing.js). They share the brand; they
 * do not share a composition.
 *
 * Any product key NOT in this registry falls back to the earlier data-driven
 * renderer in ProductDetailPage.js, so the Dashboard keeps working while the
 * remaining products are rebuilt one at a time.
 */
import FileConverterProductPage from './FileConverterProductPage';
import VirtualShopProductPage from './VirtualShopProductPage';
import ImageComposerProductPage from './ImageComposerProductPage';
import ManagedPcProtectionProductPage from './ManagedPcProtectionProductPage';
import TrackLockWipeProductPage from './TrackLockWipeProductPage';
import { makePaidUtilityCyberTechPage } from './PaidUtilityCyberTechPage';

const paidUtilityPage = (key) => makePaidUtilityCyberTechPage(key);

export const PRODUCT_PAGES = {
  'service-command-centre': paidUtilityPage('service-command-centre'),
  'website-capture-suite': paidUtilityPage('website-capture-suite'),
  'file-converter': FileConverterProductPage,
  'virtual-shop': VirtualShopProductPage,
  'image-composer': ImageComposerProductPage,
  'managed-pc-protection': ManagedPcProtectionProductPage,
  'track-lock-wipe': TrackLockWipeProductPage,
  'backup-verification-cloud': paidUtilityPage('backup-verification-cloud'),
  'contractor-compliance-vault': paidUtilityPage('contractor-compliance-vault'),
  'credential-renewal-manager': paidUtilityPage('credential-renewal-manager'),
  'compliance-evidence-vault': paidUtilityPage('compliance-evidence-vault'),
  'maintenance-and-inspection-cloud': paidUtilityPage('maintenance-and-inspection-cloud'),
  'secure-client-document-portal': paidUtilityPage('secure-client-document-portal'),
  'website-dns-ssl-uptime-monitor': paidUtilityPage('website-dns-ssl-uptime-monitor'),
  'content-planner': paidUtilityPage('content-planner'),
  'local-seo-grid-rank-monitor': paidUtilityPage('local-seo-grid-rank-monitor'),
  'equipment-service-and-calibration-manager': paidUtilityPage('equipment-service-and-calibration-manager'),
  'fleet-service-and-inspection-manager': paidUtilityPage('fleet-service-and-inspection-manager'),
};

export default PRODUCT_PAGES;
